import React from 'react';
export function PrivacyContent() {
  return <div className="space-y-6" data-id="element-1167">
      <section data-id="element-1168">
        <h4 className="text-lg font-bold text-white mb-2" data-id="element-1169">
          1. Compromiso de Privacidad
        </h4>
        <p data-id="element-1170">
          En Estrategias Digitales A-Z, respetamos su privacidad y estamos
          comprometidos a proteger sus datos personales. Esta política describe
          cómo recopilamos, usamos y protegemos la información que nos
          proporciona.
        </p>
      </section>

      <section data-id="element-1171">
        <h4 className="text-lg font-bold text-white mb-2" data-id="element-1172">
          2. Información que Recopilamos
        </h4>
        <p data-id="element-1173">
          Podemos recopilar la siguiente información cuando nos contacta o
          contrata nuestros servicios:
        </p>
        <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-1174">
          <li data-id="element-1175">
            Información de contacto: Nombre, correo electrónico, número de
            teléfono.
          </li>
          <li data-id="element-1176">
            Información del negocio: Detalles sobre su empresa, objetivos y
            requerimientos del proyecto.
          </li>
          <li data-id="element-1177">
            Datos técnicos: Dirección IP y datos de navegación para mejorar la
            experiencia en nuestro sitio (cookies).
          </li>
        </ul>
      </section>

      <section data-id="element-1178">
        <h4 className="text-lg font-bold text-white mb-2" data-id="element-1179">
          3. Uso de la Información
        </h4>
        <p data-id="element-1180">Utilizamos sus datos exclusivamente para:</p>
        <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-1181">
          <li data-id="element-1182">Proveer los servicios contratados (diseño web, consultoría).</li>
          <li data-id="element-1183">Comunicarnos con usted sobre el estado de su proyecto.</li>
          <li data-id="element-1184">
            Enviar información relevante o promociones (si ha dado su
            consentimiento).
          </li>
          <li data-id="element-1185">
            Facturación y cumplimiento de obligaciones legales en Costa Rica.
          </li>
        </ul>
      </section>

      <section data-id="element-1186">
        <h4 className="text-lg font-bold text-white mb-2" data-id="element-1187">
          4. Protección de Datos
        </h4>
        <p data-id="element-1188">
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger sus datos contra acceso no autorizado, pérdida o alteración.
          No vendemos, alquilamos ni compartimos su información personal con
          terceros con fines comerciales.
        </p>
      </section>

      <section data-id="element-1189">
        <h4 className="text-lg font-bold text-white mb-2" data-id="element-1190">5. Sus Derechos</h4>
        <p data-id="element-1191">
          Usted tiene derecho a acceder, rectificar, cancelar u oponerse al
          tratamiento de sus datos personales. Para ejercer estos derechos,
          puede contactarnos directamente a través de nuestros canales
          oficiales.
        </p>
      </section>

      <section data-id="element-1192">
        <h4 className="text-lg font-bold text-white mb-2" data-id="element-1193">6. Contacto</h4>
        <p data-id="element-1194">
          Si tiene preguntas sobre nuestra política de privacidad o el manejo de
          sus datos, contáctenos en:
        </p>
        <p className="mt-2 text-purple-400" data-id="element-1195">
          Correo: holaestrategiasaz@gmail.com
          <br data-id="element-1196" />
          Teléfono: +506 8531-6690
          <br data-id="element-1197" />
          Ubicación: San José, Costa Rica
        </p>
      </section>

      <div className="pt-4 text-sm text-gray-500 border-t border-white/10" data-id="element-1198">
        Última actualización: Febrero 2026
      </div>
    </div>;
}